import React from "react";
import { I18n } from "@aws-amplify/core";
import { get, forEach, size, isEmpty } from "lodash";

import { fetchPost } from "../../../api/fetch";

import Grid from "@material-ui/core/Grid";

import DetailsContainer from "../../Common/DetailsContainer";
import ProfileViewMatched from "../../Profiles/ProfileView/ProfileViewMatched";
import CorrectConfirmValue from "../CorrectConfirmValue/CorrectConfirmValue";
import Loader from "../../Common/Loader";
import OverrideDialog from "../OverrideDialog";
import CapturedPhotosContainer from "../CapturedPhotosContainer";
import ProfileLink from "../../Common/ProfileLink";

import { isUnknownProfile } from "../../../utils/profile";
import { formatDate } from "../../../utils/date";
import { getVehicleIdentificationPhotos } from "../../../utils/event";
import { fetchCreatedByUsers } from "../../../utils/event";

import { eventGroupsData } from "../../../constants/eventGroups";
import { truck } from "../../../constants/common";

import colors from "../../../assets/style/colors";

const LogDetailsVehicleNew = (props) => {
  const { log, typeId, refreshLog, tabs, lov, overriden } = props;

  const [photoDetails, setPhotoDetails] = React.useState(null);
  const [vehicleIdentification, setVehicleIdentification] = React.useState();
  const [isFetching, setIsFetching] = React.useState();

  React.useEffect(() => {
    setVehicleIdentification();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeId]);

  React.useEffect(() => {
    fetchVehicleIdentification();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [log, typeId]);

  const fetchVehicleIdentification = async () => {
    setIsFetching(true);
    try {
      let res = await fetchPost("new/event_groups", {
        filter: {
          parent_ids: [get(log, ["id"])],
          types: [typeId],
        },
        data: eventGroupsData,
      });
      res.items = await fetchCreatedByUsers(res.items);
      setVehicleIdentification(get(res, ["items", 0]));

      if (photoDetails !== null) {
        updatePhotoDetail(get(res, ["items", 0]));
      }
    } catch (e) {
      console.log(e);
    }
    setIsFetching(false);
  };

  const updatePhotoDetail = () => {
    let photos = getVehicleIdentificationPhotos(vehicleIdentification);
    forEach(photos, (p) => {
      if (get(p, ["url"]) === get(photoDetails, ["url"])) {
        setPhotoDetails(p);
      }
    });
  };

  if (isFetching) {
    return (
      <Grid
        container
        direction="column"
        wrap="nowrap"
        style={{ height: "100%" }}
        alignItems="center"
        justify="center"
      >
        <Grid item>
          <Loader noDecoration />
        </Grid>
      </Grid>
    );
  }

  if (size(vehicleIdentification) === 0) {
    return (
      <Grid
        container
        direction="column"
        wrap="nowrap"
        style={{ height: "100%" }}
        alignItems="center"
        justify="center"
      >
        <Grid item>
          {I18n.get(
            typeId === 10 ? "site_noVehicleDetected" : "site_noTrailerDetected"
          )}
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <CorrectConfirmValue
        section={props.section}
        open={photoDetails !== null}
        initialValue={photoDetails}
        setInitialValue={setPhotoDetails}
        close={() => setPhotoDetails(null)}
        photos={getVehicleIdentificationPhotos(vehicleIdentification)}
        profileType={props.type === truck ? 2 : 3}
        profile={get(vehicleIdentification, ["profile"])}
        detectionEventGroup={vehicleIdentification}
        refreshDetectionEventGroup={() => {
          fetchVehicleIdentification();
          refreshLog();
        }}
        reloadEventGroupAndFocusElement={() => {
          fetchVehicleIdentification();
          refreshLog();
        }}
        dacId={get(log, ["id"])}
        tabs={tabs}
      />
      <Grid
        container
        direction="column"
        alignItems="stretch"
        style={{ height: "-webkit-fill-available" }}
        wrap="nowrap"
      >
        {!isEmpty(overriden) && (
          <Grid
            item
            xs
            className="flexCenter"
            style={{
              justifyContent: "flex-end",
              paddingRight: "10px",
              color: colors.black54,
            }}
          >
            {`${I18n.get("site_overridenBy")} ${get(overriden, [
              "created_by",
            ])}, ${formatDate(get(overriden, ["created_on"]))}`}
          </Grid>
        )}
        <Grid item style={{ height: "30px", marginBottom: "20px" }}>
          <Grid container>
            <Grid item xs={4} />
            <ProfileLink
              profile={get(vehicleIdentification, ["profile"])}
              overriden={get(props, ["details", "override"])}
              score={get(props, ["vehicleIdentification", "luke_index"])}
            />
            <Grid
              item
              xs={4}
              style={{ textAlign: "right", paddingRight: "10px" }}
            >
              {/* <OverrideDialogNew
                profileType={props.type}
                currentProfile={get(vehicleIdentification, ["profile"]) || {}}
                language={props.language}
                addNote={props.addNote}
                photos={getVehicleIdentificationPhotos(vehicleIdentification)}
                tabs={tabs}
                section={props.section}
                dacId={get(log, ["id"])}
                detectionEventGroup={vehicleIdentification}
                refreshDetectionEventGroup={() => {
                  fetchVehicleIdentification();
                  refreshLog();
                }}
              /> */}
              <OverrideDialog
                profileType={props.type}
                currentProfile={get(vehicleIdentification, ["profile"]) || {}}
                details={{
                  dacId: get(log, ["id"]),
                  detectionId: get(vehicleIdentification, ["id"]),
                  handleProfileOverride: () => {
                    fetchVehicleIdentification();
                    refreshLog();
                  },
                }}
                language={props.language}
                addNote={props.addNote}
                photos={getVehicleIdentificationPhotos(vehicleIdentification)}
                tabs={tabs}
                lov={lov}
                log={props.log}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ marginBottom: "20px", width: "100%" }}>
          <CapturedPhotosContainer
            photos={getVehicleIdentificationPhotos(vehicleIdentification)}
            onClickPhoto={(element) => setPhotoDetails(element)}
          />
        </Grid>
        {!isUnknownProfile(get(vehicleIdentification, ["profile", "id"])) && (
          <Grid item>
            <DetailsContainer title={I18n.get("site_matchedProfile")}>
              <ProfileViewMatched
                profileType={get(vehicleIdentification, [
                  "profile",
                  "type",
                  "id",
                ])}
                profile={get(vehicleIdentification, ["profile"]) || {}}
                lov={lov}
                photos={get(vehicleIdentification, ["profile", "images"]) || []}
                disable={{ containerPadding: true, topBar: true }}
              />
            </DetailsContainer>
          </Grid>
        )}
        {props.powerUserMode && (
          <>
            <Grid item xs></Grid>
            <Grid
              item
              style={{
                textAlign: "right",
                fontSize: "0.875em",
                color: colors.black38,
                paddingRight: "10px",
              }}
            >
              {I18n.get("site_eventGroupId") + " "}
              <span style={{ fontStyle: "italic" }}>
                {get(vehicleIdentification, ["id"])}
              </span>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default LogDetailsVehicleNew;
